import { render } from "./AddLibraryModal.vue?vue&type=template&id=48c773ca&scoped=true"
import script from "./AddLibraryModal.vue?vue&type=script&lang=js"
export * from "./AddLibraryModal.vue?vue&type=script&lang=js"

import "../css/components/AddLibraryModal.css?vue&type=style&index=0&id=48c773ca&scoped=true&lang=css&external"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-48c773ca"]])

export default __exports__